import React from 'react';
import { FooterLink } from './footer-link';
export var FooterColumnSection = function (_a) {
    var subNav = _a.subNav, trackingCallback = _a.trackingCallback;
    return (React.createElement("ul", null, subNav.map(function (linkBuilder, i) {
        return (React.createElement(FooterLink, { key: "footerSubNav".concat(i), href: linkBuilder.url, displayText: linkBuilder.displayText, routerLink: linkBuilder.routerLink, trackingCallback: trackingCallback }));
    })));
};
